import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useGetBreakpoints } from "../../../hooks/useGetBreakpoints";
import { fetchStart, fetchSuccess } from "../../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../../util/Api";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Slider from "react-slick";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import offerPromo from "../../../assets/images/Isolation_Mode.svg";

const AdminPromotionTypeTwo = () => {
  const dispatch = useDispatch();
  const [Promotions, setPromotions] = useState([]);
  const { isMobile } = useGetBreakpoints();

  const width = window.innerWidth;
  const isTablet = width >= 768 && width < 1024;
  const isSmallLaptop = width >= 1024 && width < 1280;
  const isLaptop = width >= 1280 && width < 1440;
  const isLargeDesktop = width >= 1440;

  const getMinimumWidth = () => {
    if (isLargeDesktop) return "350px";
    if (isLaptop) return "250px";
    if (isSmallLaptop) return "250px";
    if (isTablet) return "225px";
  }

  useEffect(() => {
    fetchPromotions();
  }, [dispatch]);

  const fetchPromotions = async () => {
    try {
      dispatch(fetchStart());
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/broadcastpromotions/offers?page=1&limit=100`
      );
      const broadcastPromotions = response.data.data.rows;
      setPromotions(broadcastPromotions);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    } finally {
      dispatch(fetchSuccess());
    }
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow custom-prev-arrow" onClick={onClick}>
        <LeftOutlined style={{ color: "#FFFFFF" }} />
      </div>
    );
  };

  const NextArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow custom-next-arrow" onClick={onClick}>
        <RightOutlined style={{ color: "#FFFFFF" }} />
      </div>
    );
  };
  const settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  const filteredPromotion = Promotions.filter(
    (promotion) => promotion.bannerType === "type_3"
  );

  return filteredPromotion && filteredPromotion.length > 0 ? (
    <div className="promotion-banner-container">
      <Slider {...settings}>
        {filteredPromotion.map((promotion) => (
          <div
            key={promotion.id}
            className={
              isMobile
                ? "mobile-promotion-banner-type-two"
                : "promotion-banner-type-two"
            }
          >
            <div
              className={
                isMobile
                  ? "mobile-banner-image-type-two"
                  : "banner-image-type-two"
              }
            >
              <img src={offerPromo} alt="promo-img" />
            </div>

            <div
              style={{
                minWidth: "200px",
                height: isMobile ? "120px" : "150px",
              }}
            >
              <h2
                className={
                  isMobile
                    ? "mobile-banner-title-type-two"
                    : "banner-title-type-two"
                }
                style={{
                  minWidth: "260px",
                }}
              >
                {promotion.title}
              </h2>
              <p
                className={
                  isMobile
                    ? "mobile-banner-desc-type-two"
                    : "banner-desc-type-two"
                }
                style={{
                  maxWidth: "260px",
                  minWidth: getMinimumWidth(),
                }}
              >
                {promotion.description}
              </p>
              {promotion.urlType === "internal_url" ? (
                <Link to={`${promotion.url}`}>
                  <Button
                    className={isMobile ? "mobile-avail-now" : "avail-now"}
                  >
                    Go
                  </Button>
                </Link>
              ) : (
                <a
                  href={promotion.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    className={isMobile ? "mobile-avail-now" : "avail-now"}
                  >
                    Go
                  </Button>
                </a>
              )}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  ) : null;
};

export default AdminPromotionTypeTwo;
